<ng-container *ngFor="let child of children">
  <ng-template #blkTemplate let-style="blkStyle">
    <div
      *ngIf="getLineClamp(child)"
      [appClickableBlock]="child"
      [class]="child.uId"
      [item]="child"
      [ngStyle]="getChildStyleFixedWidthAndMargin(child, style)"
      app-block
      [disableTabIndex]="disableTabIndex"
      ellipsis
    ></div>
    <div
      *ngIf="!getLineClamp(child)"
      [appClickableBlock]="child"
      [class]="child.uId"
      [item]="child"
      [ngClass]="getSpecialBlockClassIfNecessary(child)"
      [ngStyle]="getChildStyleFixedWidthAndMargin(child, style)"
      [disableTabIndex]="disableTabIndex"
      app-block
    ></div>
  </ng-template>

  <ng-container *ngIf="child?.link?.hasLink(); else blkTemplate">
    <!--          ROBIMY TO DLATEGO ŻE NIE MOŻEMY DAĆ 2 KOMPONENTÓW (app-block i app-link) do jednego elementu -->
    <!--          a dla pustego kontenera musielibyśmy tak zrobić - dlatego póki co mamy to rozwiązanie-->
    <!--          i może kiedyś ktoś mądry ogarnie to lepiej albo coś się zmieni w samym angularze co pozwoli nam to ogarnac-->
    <!--          w razie problemów albo pretensji pisać do Dawida-->
    <ng-container *ngIf="child?.link?.hasInternalLink()">
      <a
        *ngIf="getLineClamp(child)"
        [appClickableBlock]="child"
        [class]="child.uId"
        [item]="child"
        [fragment]="child.link.hrefAnchor || null"
        [queryParams]="child.link.getQueryParams()"
        [routerLinkActiveOptions]="{ exact: false }"
        [routerLink]="child.link.getLink()"
        [target]="child.link.getTarget()"
        [attr.download]="child.link.getDownload()"
        (click)="child.link.onClickLink($event)"
        routerLinkActive="active-link"
        app-block
        [disableTabIndex]="disableTabIndex"
        ellipsis
      ></a>
      <a
        *ngIf="!getLineClamp(child)"
        [appClickableBlock]="child"
        [class]="child.uId"
        [item]="child"
        [fragment]="child.link.hrefAnchor || null"
        [queryParams]="child.link.getQueryParams()"
        [routerLinkActiveOptions]="{ exact: false }"
        [routerLink]="child.link.getLink()"
        [target]="child.link.getTarget()"
        [attr.download]="child.link.getDownload()"
        (click)="child.link.onClickLink($event)"
        routerLinkActive="active-link"
        [disableTabIndex]="disableTabIndex"
        app-block
      ></a>
    </ng-container>
    <a
      *ngIf="child?.link?.hasExternalLink()"
      [href]="child.link.getLink()"
      [attr.download]="child.link.getDownload()"
      (click)="child.link.onClickLink($event)"
      [rel]="child.link.getRel()"
      [target]="child.link.getTarget()"
      [ngStyle]="getChildStyle(child, true)"
      [attr.tabindex]="child.tabindex"
      [attr.aria-label]="child.linkDescription || null"
    >
      <ng-container [ngTemplateOutlet]="blkTemplate"
                    [ngTemplateOutletContext]="{blkStyle:{width:getChildStyleWidth(child)}}"></ng-container>
    </a>
  </ng-container>
</ng-container>
